import React, { useEffect, useState } from "react";
import { DeleteBlogs, getAllBlogsList } from "services/apiService";
import DynamicButton from "../../../common/DynamicButton.jsx";
import {
  faCirclePlus,
  faMagnifyingGlass,
  faPen,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import loadingImage from "../../../assect/loadingSvg/loading.svg";
import CommonTable from "common/CommonTable";
import No_Image_Available from "../../../assect/Images/No_Image_Available-Table.png";
import { Button } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import BlogsEdit from "./BlogsEdit";
import config from "config";

const BlogsList = () => {
  const Appurl = config.REACT_APP_IMAGE_URL;
  const [blogsData, setBlogsData] = useState([]);
  const [loader, setLoader] = useState(false);
  const [blogsSearch, setBlogsSearch] = useState("");
  const [isOpenSubPageEdit, setIsOpenSubpagesEdit] = useState<boolean>(false);
  const [selectedSubPagesId, setSelectedSubpagesId] = useState<number | null>(
    null
  );
  const headers = [
    "S.no",
    "Blog Title",
    "Blog Category Name",
    "Blog Tag Name",
    "Image",
    "Action",
  ];

  useEffect(() => {
    getBlogsData();
  }, []);

  const getBlogsData = async () => {
    setLoader(true);
    try {
      const response = await getAllBlogsList();
      setBlogsData(response.data);
    } catch (error) {
      console.error("Error fetching blog data:", error);
    } finally {
      setLoader(false);
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    setBlogsSearch(value);
  };

  const filteredBlogs = blogsData?.filter((blog) =>
    blog.title.toLowerCase().includes(blogsSearch.toLowerCase())
  );

  const handleDelete = async (id: number, name: string) => {
    try {
      const firstConfirmation = await Swal.fire({
        title: "Are you sure?",
        html: `You wanted to delete <strong style="color: orange; padding: 3px;">⚠️ ${name}</strong>`,
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "Cancel",
      });
      if (firstConfirmation.isConfirmed) {
        const secondConfirmation = await Swal.fire({
          title: "Are you really sure?",
          text: "This action cannot be undone!",
          icon: "question",
          showCancelButton: true,
          confirmButtonText: "Yes, I am sure!",
          cancelButtonText: "Cancel",
        });

        if (secondConfirmation.isConfirmed) {
          const response = await DeleteBlogs(id);
          if (response.status_code === 200) {
            Swal.fire("Deleted!", "The Blog has been deleted.", "success");
            getBlogsData();
          } else {
            Swal.fire("Error!", "Something went wrong!", "error");
          }
        } else {
          Swal.fire("Cancelled", "The Blog is safe!", "info");
        }
      }
    } catch (error) {
      Swal.fire("Error!", "An unexpected error occurred.", "error");
    }
  };

  const handleModelOpen = (id: number) => {
    setSelectedSubpagesId(id);
    setIsOpenSubpagesEdit(true);
  };

  const handleModelClose = () => {
    setIsOpenSubpagesEdit(false);
  };

  const renderRow = (blog: any, index: number) => {
    return (
      <tr className="mt-2 pt-4" key={index}>
        <td>{index + 1}</td>
        <td title={blog.title}>
          {blog.title?.length > 30
            ? blog.title?.slice(0, 30) + "..."
            : blog.title}
        </td>
        <td>{blog.blog_category_name}</td>
        <td>{blog.blog_tag_name}</td>
        <td>
          <div className="d-flex justify-content-center">
            {blog.image_path ? (
              <img
                src={`${Appurl}${blog.image_path}`}
                alt="BlogImage"
                width={100}
              />
            ) : (
              <img
                src={No_Image_Available}
                alt="No_Image_Available"
                width={100}
              />
            )}
          </div>
        </td>
        <td className="align-content-center">
          <div className="actions-buttons">
            <DynamicButton
              icon={faPen}
              iconStyle={{ color: "#63E6BE" }}
              style={{
                padding: "0",
                border: "none",
                background: "none",
                cursor: "pointer",
                margin: "2px",
              }}
              onClick={() => handleModelOpen(blog.blog_id)}
            />

            <DynamicButton
              icon={faTrash}
              iconStyle={{ color: "red" }}
              style={{
                padding: "0",
                border: "none",
                background: "none",
                cursor: "pointer",
                margin: "2px",
              }}
              onClick={() => handleDelete(blog.blog_id, blog.title)}
            />
          </div>
        </td>
      </tr>
    );
  };

  return (
    <>
      <div className="d-flex justify-content-between">
        <div className="col-lg-6">
          <Button
            component={Link}
            to="/blog-create"
            variant="contained"
            color="primary"
            sx={{ borderRadius: "0px" }}
          >
            <FontAwesomeIcon
              icon={faCirclePlus}
              style={{ marginRight: "10px" }}
            />
            Create Blog
          </Button>
        </div>
        <div className="col-lg-5 d-flex mb-3">
          <input
            type="text"
            className="form-control"
            value={blogsSearch}
            placeholder="Search Blogs"
            style={{ boxShadow: "none" }}
            onChange={handleChange}
          />
          <div className="input-group-append">
            <span className="input-group-text">
              <FontAwesomeIcon icon={faMagnifyingGlass} size="xl" />
            </span>
          </div>
        </div>
      </div>

      <div className="product-table-container">
        <div className="product-table-content">
          {loader ? (
            <div className="loadingsvg-Image text-center">
              <img
                src={loadingImage}
                width={150}
                height={150}
                alt="Loading..."
              />
            </div>
          ) : (
            <CommonTable
              data={filteredBlogs}
              isLoading={loader}
              headers={headers}
              renderRow={renderRow}
            />
          )}
        </div>
      </div>
      <BlogsEdit
        onActionComplete={() => {
          getBlogsData();
        }}
        open={isOpenSubPageEdit}
        handleClose={handleModelClose}
        id={selectedSubPagesId}
      />
    </>
  );
};

export default BlogsList;
